import _ from 'lodash';
import { getSnapshot, types } from 'mobx-state-tree';

const CustomCreativeUnitData = types.model({
    id: types.maybeNull(types.number),
    imageSrc: types.optional(types.string, ''), // S3 URL from server, or empty for new uploads
    mediaType: types.optional(types.string, 'image'), // 'image' or 'video'
    validationStatus: types.optional(types.integer, 0),
    file: types.maybeNull(types.frozen()) // File object for unsaved uploads (not serializable)
});

export const CustomCreativeUnitModel = types
    .model('CustomCreativeModel', {
        size: types.string,
        serverData: CustomCreativeUnitData,
        localData: CustomCreativeUnitData
    })
    .views((self) => ({
        isModified() {
            // Has new file uploaded, or imageSrc changed (deleted)
            return !!self.localData.file || self.serverData.imageSrc !== self.localData.imageSrc;
        },
        isDeleted() {
            return self.serverData.imageSrc && !self.localData.imageSrc && !self.localData.file;
        }
    }))
    .actions((self) => ({
        updateField(field, value) {
            if (_.has(self.localData, field)) {
                self.localData[field] = value;
            }
        },
        // Reset localData to match serverData
        resetToServerData() {
            self.localData = getSnapshot(self.serverData);
        }
    }));
